import React from "react";

const RefreshSpin = ({ isLoading, count }) => {
  return (
    <span className="badge flagged">
      {isLoading ? (
        <span className="user_heading_3">
          <i className="fa fa-refresh fa-spin" style={{ fontSize: "10px" }}></i>
        </span>
      ) : (
        count
      )}
    </span>
  );
};

export default RefreshSpin;
